class CartNotification extends HTMLElement {
  connectedCallback() {
    this.productEl = this.querySelector('[data-cart-notification-product]');
    this.checkoutBtn = this.querySelector('.cart-notification__checkout');
    this.cart = null;
    this.lastFocused = null;

    this.onKeydown = this.onKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    this.querySelectorAll('[data-cart-notification-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', () => this.pushBeginCheckout());
    }

    if (window.MX) {
      this.unsubscribe = window.MX.subscribe('cart:added', ({ item, cart }) => {
        this.cart = cart;
        this.render(item, cart);
        this.open();
      });
    }
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);
  }

  static escape(str) {
    const el = document.createElement('div');
    el.textContent = str == null ? '' : String(str);
    return el.innerHTML;
  }

  static money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format((cents || 0) / 100);
    } catch (err) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  render(item, cart) {
    if (!this.productEl || !item) return;
    const esc = CartNotification.escape;

    let media = '';
    const src = item.featured_image && item.featured_image.url;
    if (src) {
      const sized = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      media =
        '<img class="cart-notification__img" src="' +
        esc(sized) +
        '" alt="' +
        esc((item.featured_image && item.featured_image.alt) || item.product_title || '') +
        '" width="70" height="70" loading="lazy">';
    }

    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-notification__variant">' + esc(item.variant_title) + '</p>'
        : '';

    const qtyLabel = (this.dataset.qtyLabel || 'Qty') + ' ' + (item.quantity || 1);

    this.productEl.innerHTML =
      media +
      '<div class="cart-notification__details">' +
      '<p class="cart-notification__name">' +
      esc(item.product_title || item.title) +
      '</p>' +
      variant +
      '<p class="cart-notification__meta">' +
      esc(qtyLabel) +
      ' · ' +
      CartNotification.money(item.final_line_price, cart && cart.currency) +
      '</p>' +
      '</div>';
  }

  open() {
    if (!this.hidden) return;
    this.lastFocused = document.activeElement;
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));

    const close = this.querySelector('.cart-notification__close');
    if (close) close.focus();

    document.addEventListener('keydown', this.onKeydown);
    setTimeout(() => document.addEventListener('click', this.onDocumentClick), 0);
  }

  close() {
    if (this.hidden) return;
    this.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);

    const done = () => {
      this.hidden = true;
      this.removeEventListener('transitionend', done);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      done();
    } else {
      this.addEventListener('transitionend', done);
      setTimeout(done, 400);
    }

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  pushBeginCheckout() {
    const cart = this.cart;
    if (!cart || !window.dataLayer) return;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        currency: cart.currency,
        value: (cart.total_price || 0) / 100,
        items: (cart.items || []).map((line) => ({
          item_id: line.sku,
          item_name: line.product_title,
          item_brand: line.vendor,
          price: (line.final_price || 0) / 100,
          quantity: line.quantity,
        })),
      },
    });
  }
}
customElements.define('cart-notification', CartNotification);
